module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [(_vm.type === 'textarea') ? [_c('textarea', {
    style: (_vm.textarea_style),
    attrs: {
      "rows": _vm.rows,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.$emit('enter')
      },
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        _vm.$emit('input', _vm.reformStr($event.target.value)), _vm.$emit('change', _vm.reformStr($event.target.value))
      }
    }
  }), _vm._v(" "), _c('textarea', {
    ref: 'hidden_textarea',
    staticClass: "hidden-textarea",
    attrs: {
      "rows": _vm.rows
    },
    domProps: {
      "value": _vm.value
    }
  })] : _c('input', {
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.$emit('enter')
      },
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        _vm.$emit('input', _vm.reformStr($event.target.value)), _vm.$emit('change', _vm.reformStr($event.target.value))
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b51d8a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/components/InputField.vue
// module id = 663
// module chunks = 0